import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const HistoryTimeline = {
	/** @description Cache DOM elements */
	$timelineLine: document.querySelector('.js-timeline-fill'),
	$timelineItems: document.querySelectorAll('.js-timeline-item'),

	/** @description Initialize */
	init: function() {
		if (!this.$timelineLine || this.$timelineItems.length === 0) return;
		this.animateLine();
		this.bindScrollAnimations();
	},

	/** @description Animate timeline line */
	animateLine: function() {
		gsap.to(this.$timelineLine, {
			scaleY: 1,
			ease: 'linear',
			scrollTrigger: {
				trigger: '.js-timeline-container',
				start: 'top center',
				end: 'bottom center',
				scrub: true,
			}
		});
	},

	/** @description Bind scroll animations */
	bindScrollAnimations: function() {
		this.$timelineItems.forEach(item => {
			ScrollTrigger.create({
				trigger: item,
				start: 'top center',
				onEnter: () => {
					item.classList.add('is-active');
				},
				onLeaveBack: () => {
					item.classList.remove('is-active');
				}
			});
		});
	}
};

export default HistoryTimeline;
